import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ProcedurePage from './ProcedurePage';
import ProcedureTabState from './ProcedureTabState';

// Set options for a `versionApiId` the page reports. The page already shows that version, so the
// tab view skips re-rendering for it.
const PAGE_VERSION_CHANGE_OPTIONS: Backbone.ModelSetOptions & {fromPage: boolean} = {fromPage: true};

export default class ProcedureTabView extends BufferTabView<ProcedureTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    this.listenTo(
      this.model,
      'change:versionApiId',
      (_model: ProcedureTabState, _versionApiId: string | undefined, options: {fromPage?: boolean}) => {
        if (!options.fromPage) {
          this.render();
        }
      }
    );
  }

  override render(): this {
    const props = {
      procedureId: this.model.get('procedureId'),
      flowchartVersionId: this.model.get('versionApiId'),
      onVersionChange: (versionApiId: string | undefined) =>
        this.model.set('versionApiId', versionApiId, PAGE_VERSION_CHANGE_OPTIONS),
    };
    this.reactRoot = renderToDOM(
      <ProcedurePage {...props} key={props.flowchartVersionId} />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ProcedureTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
